import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { AppService } from 'src/app/core/services/app.service';
import { FocuslinkService } from 'src/app/core/services/focuslink.service';
import { FocuspayReportingService } from 'src/app/core/services/focuspay-reporting.service';
import { OOVenueService } from 'src/app/core/services/venue-service';
import { DatacapBatchRecord } from 'src/app/shared/models/DTO/FocusPayDatacap/DatacapReportSummary.dto';

@Component({
	selector: 'app-credit-dashboard-header',
	templateUrl: './credit-dashboard-header.component.html',
	styleUrls: ['../../../commandcenter.scss'],
})
export class CreditDashboardHeaderComponent implements OnInit, OnDestroy {
	@Input() batchRecord: DatacapBatchRecord;

	batchRecords: DatacapBatchRecord[] = [];
	batchRecordSubscription: Subscription;

	currentDayBatchRecord: DatacapBatchRecord;
	previousDayBatchRecord: DatacapBatchRecord;

	displayDashboard: boolean = true;

	constructor(
		public app: AppService,
		public venueService: OOVenueService,
		private focuslink: FocuslinkService,
		public focusPayReportingService: FocuspayReportingService
	) {}

	ngOnDestroy(): void {
		this.batchRecordSubscription && this.batchRecordSubscription.unsubscribe();
	}

	ngOnInit(): void {
		if (!this.batchRecord) {
			this.batchRecordSubscription = this.focusPayReportingService.batchRecords.subscribe((batchRecords) => {
				this.batchRecords = [...batchRecords];
				this.buildDashboard(batchRecords);
			});
		} else {
			this.currentDayBatchRecord = this.batchRecord;
		}
	}

	buildDashboard(batchRecords: DatacapBatchRecord[]) {
		this.currentDayBatchRecord = batchRecords.find((batchRecord) => batchRecord.businessDate === this.app.moment().format('MMDDYYYY'));

		if (!this.currentDayBatchRecord) {
			this.currentDayBatchRecord = new DatacapBatchRecord({
				businessDate: this.app.moment().format('MMDDYYYY'),
				amount: 0,
				transactionCount: 0,
			});
		}

		this.previousDayBatchRecord = batchRecords.find((batchRecord) => batchRecord.businessDate === this.app.moment().add(-1, 'days').format('MMDDYYYY'));
	}
}
